var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWealth105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M24.5 9a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19ZM14 18.5C14 12.701 18.701 8 24.5 8S35 12.701 35 18.5 30.299 29 24.5 29 14 24.299 14 18.5ZM35 39h31.5a.5.5 0 0 0 0-1h-48a8.5 8.5 0 0 0-8.5 8.5v50a.5.5 0 0 0 1 0v-50a7.5 7.5 0 0 1 7.5-7.5H34v57.5a.5.5 0 0 0 1 0V39Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M57 8.5a.5.5 0 0 0-1 0V16h-9.5a.5.5 0 0 0 0 1H94v51H46.5a.5.5 0 0 0 0 1h23.67l11.87 27.697a.5.5 0 1 0 .92-.394L71.258 69H94.5a.5.5 0 0 0 .5-.5v-52a.5.5 0 0 0-.5-.5H57V8.5Z",
  clipRule: "evenodd"
})));
export { SvgWealth105 as ReactComponent };
export default __webpack_public_path__ + "b9ad36604f296e31d27600b450d5d38d.svg";